import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'ice',
      d: 'M-5,-1.5h0.5v0.5h-0.5zM5.5,-1.5h0.5v0.5h-0.5zM5.5,-1h1v0.5h-1zM4.5,-0.5h2v1.5h-2zM2.5,0h0.5v0.5h-0.5zM-6,0.5h1v0.5h-1zM-2,0.5h5v0.5h-5zM-4.5,1h9.5v0.5h-9.5zM-1,1.5h4v0.5h-4z',
    },
    {
      paint: 'snowCap',
      d: 'M-4,-3h0.5v0.5h-0.5zM-3,-2h2.5v0.5h-2.5zM-5.5,-1.5h0.5v0.5h-0.5zM-3,-1.5h4.5v0.5h-4.5zM3,-1.5h2.5v0.5h-2.5zM-6,-1h1.5v1h-1.5zM-3,-1h1.5v1h-1.5zM-1,-1h4.5v0.5h-4.5zM4,-1h1.5v0.5h-1.5zM-1,-0.5h4v0.5h-4zM4,-0.5h0.5v0.5h-0.5zM-6.5,0h1.5v0.5h-1.5zM-2.5,0h0.5v0.5h-0.5zM-0.5,0h3v0.5h-3zM-5,0.5h3v0.5h-3z',
    },
    {
      paint: 'epicJade',
      d: 'M5.5,-10.5h0.5v0.5h-0.5zM5,-10h1.5v0.5h-1.5zM-3.5,-9.5h2.5v0.5h-2.5zM4,-9.5h2.5v0.5h-2.5zM-4,-9h2v1h-2zM-1.5,-9h1.5v0.5h-1.5zM3.5,-9h3v0.5h-3zM-1.5,-8.5h6v0.5h-6zM5,-8.5h1.5v0.5h-1.5zM-5,-8h0.5v1h-0.5zM-3.5,-8h1.5v1h-1.5zM-1,-8h7.5v0.5h-7.5zM-1,-7.5h3v0.5h-3zM2.5,-7.5h2.5v1h-2.5zM5.5,-7.5h1v0.5h-1zM-5.5,-7h1v0.5h-1zM-4,-7h1v0.5h-1zM0,-7h2v0.5h-2zM5.5,-7h0.5v0.5h-0.5zM-5.5,-6.5h1.5v0.5h-1.5zM0.5,-6.5h1.5v0.5h-1.5zM3,-6.5h2.5v0.5h-2.5zM-6,-6h1.5v0.5h-1.5zM1.5,-6h0.5v0.5h-0.5zM2.5,-6h2.5v0.5h-2.5zM-6,-5.5h1v0.5h-1zM2.5,-5.5h1v0.5h-1zM-6.5,-5h1v1h-1zM-7,-4h1.5v0.5h-1.5zM-7,-3.5h1v1h-1zM-4,-3.5h0.5v0.5h-0.5zM-7,-2.5h0.5v0.5h-0.5zM-4.5,-2.5h1.5v0.5h-1.5zM3.5,-1h0.5v0.5h-0.5zM-5,0h0.5v0.5h-0.5zM4,0h0.5v0.5h-0.5zM3,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'epicCrystal',
      d: 'M5,-12h1v0.5h-1zM4.5,-11.5h1.5v0.5h-1.5zM-3.5,-11h2.5v0.5h-2.5zM4,-11h2v0.5h-2zM-4.5,-10.5h4.5v0.5h-4.5zM3,-10.5h2.5v0.5h-2.5zM-5,-10h10v0.5h-10zM-5,-9.5h1.5v0.5h-1.5zM-1,-9.5h5v0.5h-5zM-5.5,-9h1v1h-1zM0,-9h3.5v0.5h-3.5zM-6,-8h1v1h-1zM-6.5,-7h1v1h-1zM-6.5,-6h0.5v0.5h-0.5zM-7,-5.5h1v0.5h-1zM-7,-5h0.5v1h-0.5z',
    },
    {
      paint: 'epicMagic',
      d: 'M-3,-7h1v0.5h-1zM-1.5,-7h0.5v0.5h-0.5zM6,-7h0.5v0.5h-0.5zM-4,-6.5h4v0.5h-4zM5.5,-6.5h1v0.5h-1zM-4.5,-6h5v0.5h-5zM5,-6h2v0.5h-2zM-5,-5.5h6.5v0.5h-6.5zM3.5,-5.5h3.5v0.5h-3.5zM-5.5,-5h2v0.5h-2zM0,-5h7v0.5h-7zM-5.5,-4.5h1.5v0.5h-1.5zM0.5,-4.5h6v0.5h-6zM-5.5,-4h1v0.5h-1zM1.5,-4h4v0.5h-4zM-6,-3.5h1v0.5h-1zM2,-3.5h2.5v0.5h-2.5z',
    },
    {
      paint: 'epicPortal',
      d: 'M-4.5,-9h0.5v1h-0.5zM-2,-9h0.5v1h-0.5zM4.5,-8.5h0.5v0.5h-0.5zM-4.5,-8h1v1h-1zM-2,-8h1v1h-1zM2,-7.5h0.5v1h-0.5zM5,-7.5h0.5v1h-0.5zM-4.5,-7h0.5v0.5h-0.5zM-2,-7h0.5v0.5h-0.5zM2,-6.5h1v0.5h-1zM2,-6h0.5v0.5h-0.5z',
    },
    {
      paint: 'pine',
      d: 'M-4.5,-2h1.5v2h-1.5zM-1.5,-1h0.5v1h-0.5zM3,-0.5h1v1h-1zM-4.5,0h2v0.5h-2zM-2,0h1.5v0.5h-1.5z',
    },
  ],
  pixels: 498,
};
export const sprites: readonly PixelSprite[] = [variant0];
